module.exports = __webpack_public_path__ + "static/img/bg_jp.b9b67fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmasSaled-2025/bg_jp.png
// module id = wxRG
// module chunks = 1